import api from './api'

export default {
  namespaced: true,
  state: {
    routeKey: 'mediaId',
    routes: {
      index: 'fighters.media.index',
      create: 'fighters.media.create',
      edit: 'fighters.media.edit'
    },
    table: [
      { code: 'weight', type: 'integer', sort: true },
      { code: 'publish', type: 'boolean' },
      { code: 'image', type: 'image', width: 250 },
      { code: 'iframe', type: 'iframe', width: 250 },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'publish', type: 'boolean' },
      { code: 'weight', type: 'text', validation: { required: true, integer: true } },
      { code: 'iframe', type: 'text' },
      { code: 'image', type: 'image' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: 'weight'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data || null
      state.meta = data.meta || null
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        publish: data.publish === true ? 1 : null,
        weight: data.weight || null,
        iframe: data.iframe || null,
        image_old: data.image || null,
        image: null,
        image_delete: null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }, { route }) {
      const { data } = await api.index(route.params.fighterId, {
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.fighterId, route.params.mediaId)

      commit('SET_ITEM', data)
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async createItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.store(route.params.fighterId, form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.fighterId, route.params.mediaId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { route, id }) {
      await api.destroy(route.params.fighterId, id)
    }
  }
}
